import React, { useState, useContext, useEffect } from "react";

import { Grid, Grow, Tooltip } from "@material-ui/core";
import Icon from "@material-ui/core/Icon";

import Card from "../../../../components/cards/Card";
import TextField from "../../../../components/basics/TextFieldErp";
import Chip from "../../../../components/basics/Chip";
import Fieldset from "../../../../components/basics/Fieldset";
import Btn from "../../../../components/buttons/Btn";
import Select from "../../../../components/basics/SelectErp";
import SearchDialog from "../../../../patterns/modals/SearchDialog";

import { ParametrosProdutoContext } from "../contexts/ParametrosProdutoContext";
import useEmissaoController from "../controllers/EmissaoController";
import { EmissaoContext } from "../contexts/EmissaoContext";

import { Importacao, Margin } from "../styles/Emissao";
import SearchSelect from "../../../../components/inputs/SearchSelect";
import {
  CheckOutlined,
  EditOutlined,
  ReplayOutlined,
} from "@material-ui/icons";
import TextFieldErp from "../../../../components/basics/TextFieldErp";
import { notify } from "../../../../utils/notify";
import useCalculosTributacao from "../controllers/RulesEmissaoCalculosTributacao";

import { findProdutosAlternativeFlat } from "../../../../repositories/qerpapi/erp/estoque/v1/formatters/ProdutoFormatters";

const TabEmissaoDadosProduto = ({ ...props }) => {
  const {
    /* Principal */
    productData,
    productError,
    productDataStock,
    setProductDataStock,
    productDataCode,
    productDataNcm,
    setProductDataNcm,
    productDataCest,
    setProductDataCest,
    productDataCfop,
    setProductDataCfop,
    productDataUn,
    setProductDataUn,
    productDataQuantity,
    setProductDataQuantity,
    productDataUnityValue,
    setProductDataUnityValue,
    productDataTotalValue,
    setProductDataTotalValue,
    /* Outras Informações */
    productOthersGtin,
    setProductOthersGtin,
    productOthersTaxGtin,
    setProductOthersTaxGtin,
    productOthersTipi,
    setProductOthersTipi,
    productOthersDeliveryUn,
    setProductOthersDeliveryUn,
    productOthersTaxUn,
    setProductOthersTaxUn,
    productOthersTaxQuantity,
    setProductOthersTaxQuantity,
    productOthersTaxValue,
    setProductOthersTaxValue,
    productOthersFreight,
    setProductOthersFreight,
    productOthersSafe,
    setProductOthersSafe,
    productOthersDiscount,
    setProductOthersDiscount,
    productOthersExpense,
    setProductOthersExpense,
    productOthersWeightUn,
    setProductOthersWeightUn,
    productOthersWeightIm,
    setProductOthersWeightIm,
    productOthersAdditional,
    setProductOthersAdditional,
    productDataId,
  } = useContext(ParametrosProdutoContext);

  const {
    nfeListCfop,
    nfeListStockLocation,
    nfeFinancialIssue,
    visualizationOnly,
  } = useContext(EmissaoContext);

  const {
    handleSelectProduct,
    handleQuantityProduct,
    handleSelectNcm,
    handleSearchProductByCode,
    handleSelectProductBySelect,
    handleNcm,
    getCodeBarProduct,
    getDescriptionProduct,
    handleSetQuantityTrib,
  } = useEmissaoController();

  const { handleCreditIcms } = useCalculosTributacao();

  useEffect(() => {
    handleQuantityProduct();
  }, [productDataQuantity, productDataUnityValue, handleQuantityProduct]);

  const [openModalProduto, setOpenModalProduto] = useState(false);
  const [openModalNcm, setOpenModalNcm] = useState(false);

  const columnsProductSearch = [
    {
      label: "Codigo",
      format: (value) => {
        return <>{getCodeBarProduct(value, "TabEmissaoDadosProduto")}</>;
      },
    },
    {
      label: "Descrição",
      format: (value) => {
        return <>{getDescriptionProduct(value, "TabEmissaoDadosProduto")}</>;
      },
    },
    {
      label: "Código Adicional",
      id: "codbarras_codigoalternativo",
      format: (item) =>
        item.codbarras_codigoalternativo
          ? item.codbarras_codigoalternativo
          : "-",
    },
    {
      label: "Qtd. Venda Cod. Adicional",
      id: "qtdvenda_codigoalternativo",
      format: (item) =>
        item.qtdvenda_codigoalternativo ? item.qtdvenda_codigoalternativo : "-",
    },
    {
      label: "Desc. Cod. Adicional",
      id: "perc_desc_codigoalternativo",
      format: (item) =>
        item.perc_desc_codigoalternativo
          ? `% ${item.perc_desc_codigoalternativo}`
          : "-",
    },
  ];

  const columnsNcmSearch = [
    { label: "Ncm", id: "ncm" },
    { label: "Descrição", id: "descricao" },
  ];

  return (
    <Importacao>
      {openModalProduto && (
        <SearchDialog
          open={openModalProduto}
          setOpen={setOpenModalProduto}
          columns={columnsProductSearch}
          handleRequestArray={findProdutosAlternativeFlat}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectProduct}
          route="estoque/produtos/v1/porcodigobarrauniao"
          rawUrl={`idStockLocation=${
            productDataStock?.id || ""
          }&active=SIM&travarnf=0`}
          urlFilters="description,productId,codeBar"
          title="PRODUTOS"
          filter="descricao,codigobarras"
          rowId={"descricao_final"}
        />
      )}
      {openModalNcm && (
        <SearchDialog
          open={openModalNcm}
          setOpen={setOpenModalNcm}
          columns={columnsNcmSearch}
          selectable={true}
          multiSelect={false}
          handleMainClick={handleSelectNcm}
          route="nf/ncms/v1"
          title="NCM"
          filter="descricao,ncm"
        />
      )}
      <Grid container spacing={2}>
        <Grow in={true}>
          <Grid item lg={12}>
            <Card line="left">
              <Grid container spacing={2}>
                <Grid
                  item
                  lg={12}
                  sm={12}
                  justifyContent="center"
                  alignItems="center"
                  container
                >
                  <Chip
                    productHeader
                    label={
                      <HeaderLabel visualizationOnly={visualizationOnly} />
                    }
                    bgcolor="secondary"
                  />
                </Grid>
                {!visualizationOnly && (
                  <Grid item sm={3}>
                    <Select
                      variant="filled"
                      optionsList={nfeListStockLocation}
                      descriptionField="descricao"
                      label="Local de Estoque"
                      value={productDataStock}
                      setValue={setProductDataStock}
                    />
                  </Grid>
                )}
                <Grid item sm={3}>
                  <TextField
                    variant="filled"
                    value={productDataCode}
                    error={productError.productDataCode ? true : false}
                    helperText={productError.productDataCode || ""}
                    onChange={handleSearchProductByCode}
                    label="Código"
                    size="small"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={!visualizationOnly ? 5 : 8}>
                  <SearchSelect
                    customChange={true}
                    descriptionField="descricao_final"
                    variant="filled"
                    value={productData}
                    onChange={handleSelectProductBySelect}
                    handleRequestArray={findProdutosAlternativeFlat}
                    label="Descrição"
                    rawUrl={`idStockLocation=${
                      productDataStock?.id || ""
                    }&active=SIM&travarnf=0`}
                    route="estoque/produtos/v1/porcodigobarrauniao"
                    urlFilters="description,productId,codeBar"
                    filter="descricao,codigobarras"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item>
                  <Btn
                    onClick={() => setOpenModalProduto(true)}
                    label={<Icon>search</Icon>}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={2} sm={4}>
                  <TextField
                    value={productDataNcm}
                    setValue={setProductDataNcm}
                    label="NCM"
                    size="small"
                    error={productError.productDataNcm ? true : false}
                    helperText={productError.productDataNcm || ""}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item>
                  <Btn
                    onClick={() => {
                      setOpenModalNcm(true);
                    }}
                    label={<Icon>search</Icon>}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={2} sm={5}>
                  <TextField
                    value={productDataCest}
                    setValue={setProductDataCest}
                    label="CEST"
                    size="small"
                    error={productError.productDataCest ? true : false}
                    helperText={productError.productDataCest || ""}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm>
                  <Select
                    optionsList={nfeListCfop}
                    descriptionField="cfop"
                    label="CFOP"
                    value={productDataCfop}
                    onChange={(newValue) => {
                      if (newValue !== productDataCfop) {
                        setProductDataCfop(newValue);
                        handleNcm({
                          ncm: productDataNcm,
                          productId: productDataId,
                          cfop: newValue?.cfop,
                        });
                      }
                    }}
                    error={productError.productDataCfop ? true : false}
                    helperText={productError.productDataCfop || ""}
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={1}>
                  <TextField
                    value={productDataUn}
                    setValue={setProductDataUn}
                    error={productError.productDataUn ? true : false}
                    helperText={productError.productDataUn || ""}
                    label="UN"
                    size="small"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item lg={1} sm={2}>
                  <TextField
                    value={productDataQuantity}
                    setValue={setProductDataQuantity}
                    error={productError.productDataQuantity ? true : false}
                    helperText={productError.productDataQuantity || ""}
                    decimals={4}
                    onBlur={({ target: { value } }) => {
                      handleSetQuantityTrib({ value });
                    }}
                    label="Quantidade"
                    mask="decimal"
                    size="small"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm={2}>
                  <TextField
                    value={productDataUnityValue}
                    setValue={setProductDataUnityValue}
                    onBlur={() => handleCreditIcms()}
                    error={productError.productDataUnityValue ? true : false}
                    helperText={productError.productDataUnityValue || ""}
                    label="Valor Unitário R$"
                    size="small"
                    decimals={5}
                    mask="decimal"
                    disabled={visualizationOnly}
                  />
                </Grid>
                <Grid item sm>
                  <TextField
                    value={productDataTotalValue}
                    setValue={setProductDataTotalValue}
                    label="Total R$"
                    disabled
                    variant="filled"
                    mask="decimal"
                    size="small"
                  />
                </Grid>
                <Grid item sm={12}>
                  <TextField
                    value={productOthersAdditional}
                    setValue={setProductOthersAdditional}
                    label="Informações Adicionais do Produto"
                    size="small"
                    disabled={visualizationOnly}
                  />
                </Grid>
              </Grid>
              <Margin top="30" bottom="20">
                <Fieldset
                  bgcolor="white"
                  titulo={<Chip label="OUTRAS INFORMAÇÕES" />}
                  textcolor="black"
                  defaultExpanded={false}
                  accordion
                >
                  <Grid container spacing={2}>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersGtin}
                        setValue={setProductOthersGtin}
                        label="GTIN(EAN)"
                        size="small"
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersTaxGtin}
                        setValue={setProductOthersTaxGtin}
                        label="GTIN Tributável"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersTipi}
                        setValue={setProductOthersTipi}
                        label="EX TIPI"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersDeliveryUn}
                        setValue={setProductOthersDeliveryUn}
                        label="UN Entrega"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersTaxUn}
                        setValue={setProductOthersTaxUn}
                        label="UN Tributável"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersTaxQuantity}
                        setValue={setProductOthersTaxQuantity}
                        decimals={4}
                        label="Qtd. Tributável"
                        mask="decimal"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersTaxValue}
                        setValue={setProductOthersTaxValue}
                        label="Valor Tributável"
                        mask="decimal"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>

                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersFreight}
                        setValue={setProductOthersFreight}
                        label="Frete R$"
                        mask="decimal"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersSafe}
                        setValue={setProductOthersSafe}
                        label="Seguro R$"
                        mask="decimal"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersDiscount}
                        setValue={setProductOthersDiscount}
                        label="Desconto R$"
                        mask="decimal"
                        decimals="5"
                        size="small"
                        disabled={
                          nfeFinancialIssue === "VENDA" || visualizationOnly
                        }
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersExpense}
                        setValue={setProductOthersExpense}
                        label="Outras Despesas R$"
                        mask="decimal"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersWeightUn}
                        setValue={setProductOthersWeightUn}
                        label="Peso Unitário"
                        mask="decimal"
                        decimals="3"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                    <Grid item lg={2} sm={3}>
                      <TextField
                        value={productOthersWeightIm}
                        setValue={setProductOthersWeightIm}
                        label="Peso Importação"
                        mask="decimal"
                        size="small"
                        disabled={visualizationOnly}
                      />
                    </Grid>
                  </Grid>
                </Fieldset>
              </Margin>
            </Card>
          </Grid>
        </Grow>
      </Grid>
    </Importacao>
  );
};

const HeaderLabel = ({ visualizationOnly }) => {
  const { productDataDescription, setProductDataDescription, productData } =
    useContext(ParametrosProdutoContext);

  const [isEditingDescription, setIsEditingDescription] = useState(false);

  return productDataDescription ? (
    !isEditingDescription ? (
      <>
        {productDataDescription}
        {!visualizationOnly && (
          <Tooltip title="Editar descrição">
            <EditOutlined
              onClick={() => {
                setIsEditingDescription(true);
              }}
            />
          </Tooltip>
        )}
      </>
    ) : (
      <>
        <TextFieldErp
          variant="standard"
          value={productDataDescription}
          onChange={(event) => {
            if (event.target.value === "") {
              setProductDataDescription(
                productData.descricao_final?.split("|")[1].trim() || ""
              );
              setIsEditingDescription(false);
              return notify("A descrição prcisa ser informada!");
            }

            setProductDataDescription(event.target.value.slice(0, 120));
          }}
          maxLength={120}
          textAlignCenter
        />
        <Tooltip title="Confirmar">
          <CheckOutlined
            onClick={() => {
              setIsEditingDescription(false);
            }}
          />
        </Tooltip>
        <Tooltip title="Reiniciar">
          <ReplayOutlined
            onClick={() => {
              setProductDataDescription(
                productData.descricao_final?.split("|")[1].trim() || ""
              );
            }}
          />
        </Tooltip>
      </>
    )
  ) : (
    "PRINCIPAL"
  );
};

export default TabEmissaoDadosProduto;
